(function() {

var PRODUCTS = [
  {"Produkt":"Gold Collagen Forte","Brand":"Gold Collagen","Množství kolagenu":"5","Koenzym Q10":"25mg","Kyselina hyaluronová/ hyalutonát sodný":"40mg","L-karnosin":"60mg","Vitamín C - kys.L-askorbová":"80mg"},
  {"Produkt":"Collavio exclusive trio","Brand":"Lovio","Množství kolagenu":"5 g","Koenzym Q10":"10mg","Kyselina hyaluronová/ hyalutonát sodný":"30mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"160 mg"},
  {"Produkt":"About Your Beauty","Brand":"WeCare","Množství kolagenu":"2,5 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"150mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"80mg"},
  {"Produkt":"Collagen Drink","Brand":"Česká apotéka","Množství kolagenu":"5 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":"30 mg"},
  {"Produkt":"The Solution","Brand":"Oslo Skin Lab","Množství kolagenu":"2,5 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Beauty Focus Collagen+","Brand":"Nu Skin","Množství kolagenu":"2,5 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Inca Collagen","Brand":"Inca Collagen","Množství kolagenu":"3 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Prémiový kolagen jahoda","Brand":"Jíme zdravě","Množství kolagenu":"5 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"50mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"200mg"},
  {"Produkt":"Bioaktivní mořský kolagen","Brand":"Collalloc","Množství kolagenu":"3,3 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Collagen (Bloom Robbins)","Brand":"Bloom Robbins","Množství kolagenu":"7g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Complete Collagen","Brand":"Noordcode","Množství kolagenu":"8450 mg","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":"113 mg"},
  {"Produkt":"5000 Beauty Collagen Drink","Brand":"Collabelle","Množství kolagenu":"5025 mg","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"50mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"50mg"},
  {"Produkt":"Dermavit","Brand":"Advance","Množství kolagenu":"70 mg","Koenzym Q10":"5mg","Kyselina hyaluronová/ hyalutonát sodný":"10mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"20 mg"},
  {"Produkt":"Invita Skin Beauty","Brand":"Inventia","Množství kolagenu":"380 mg","Koenzym Q10":"40 mg","Kyselina hyaluronová/ hyalutonát sodný":"15mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Kolagenový nápoj s CBD","Brand":"iamCBD","Množství kolagenu":"4 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"13mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"80 mg"},
  {"Produkt":"Premium Collagen Complex","Brand":"Golden Tree","Množství kolagenu":"4 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":"230 mg"},
  {"Produkt":"Kloubus","Brand":"Kloubus","Množství kolagenu":"2730 mg","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"10 mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"250 mg"},
  {"Produkt":"Collagen Hyaluro","Brand":"Natural Medicaments","Množství kolagenu":"4 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"10 mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"53 mg"},
  {"Produkt":"Venira Premium","Brand":"Venira","Množství kolagenu":"4000 mg","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"50 mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"80 mg"},
  {"Produkt":"MetaPWR Advantage","Brand":"doTERRA","Množství kolagenu":"3 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Collagen Beauty Remedy","Brand":"Vild Nord","Množství kolagenu":"5 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Premium Collagen Peptides","Brand":"Nupreme","Množství kolagenu":"8 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Collagen Drink (DrMax)","Brand":"Dr.Max","Množství kolagenu":"10 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Collagen Beauty","Brand":"KolagenDrink","Množství kolagenu":"10020 mg","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Premium Marine Collagen","Brand":"Neobotanics","Množství kolagenu":"5g","Koenzym Q10":"100µg","Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Marine Collagen Matrix","Brand":"MCE Pharma","Množství kolagenu":"5g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Rybí kolagen (Endala)","Brand":"Endala","Množství kolagenu":"3g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Kolagen original premium","Brand":"Allnature","Množství kolagenu":"10 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Collagen Forte (Greenfood)","Brand":"Greenfood","Množství kolagenu":"5 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"30 mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"80 mg"},
  {"Produkt":"Pure Collagen","Brand":"Puravia","Množství kolagenu":"7,5 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Marine Collagen (Nordic)","Brand":"Nordic Naturals","Množství kolagenu":"4,2 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":"45 mg"},
  {"Produkt":"Verisol Collagen Silk","Brand":"Gold Fitness","Množství kolagenu":"2,5 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":"80 mg"},
  {"Produkt":"Collagen Premium (Biostile)","Brand":"Biostile","Množství kolagenu":"8620 mg","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"75 mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"50 mg"},
  {"Produkt":"Kolagen jahoda (Natural Protein)","Brand":"Natural Protein","Množství kolagenu":"6,3 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Upgraded Collagen Complex","Brand":"Powerlogy","Množství kolagenu":"13,2 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Hydrolyzovaný kolagen (BrainMarket)","Brand":"BrainMarket","Množství kolagenu":"12 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":0,"L-karnosin":0,"Vitamín C - kys.L-askorbová":0},
  {"Produkt":"Prémiový kolagen","Brand":"Mandimu","Množství kolagenu":"5 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"100mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"1000mg"},
  {"Produkt":"Prémiový kolagenový drink","Brand":"deNatura","Množství kolagenu":"5 g","Koenzym Q10":"30mg","Kyselina hyaluronová/ hyalutonát sodný":"200mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"500mg"},
  {"Produkt":"Kolagen","Brand":"Ovonex","Množství kolagenu":"4 g","Koenzym Q10":0,"Kyselina hyaluronová/ hyalutonát sodný":"190mg","L-karnosin":0,"Vitamín C - kys.L-askorbová":"200mg"},
  {"Produkt":"Kolagen","Brand":"GlowGEN","Množství kolagenu":"4 g","Koenzym Q10":"0","Kyselina hyaluronová/ hyalutonát sodný":"0","L-karnosin":0,"Vitamín C - kys.L-askorbová":"45mg"}
];

  // Kolagenový efekt — natvrdo zadaná % z CSV (null = nezjištěno → zobrazí se —)
  var KOLAGEN_EFEKT = {
    "Gold Collagen Forte": null,
    "Collavio exclusive trio": 100,
    "About Your Beauty": 100,
    "Collagen Drink": 100,
    "The Solution": 100,
    "Beauty Focus Collagen+": 50,
    "Inca Collagen": null,
    "Prémiový kolagen jahoda": 100,
    "Bioaktivní mořský kolagen": 65,
    "Collagen (Bloom Robbins)": 100,
    "Complete Collagen": 100,
    "5000 Beauty Collagen Drink": 50,
    "Dermavit": null,
    "Invita Skin Beauty": null,
    "Kolagenový nápoj s CBD": null,
    "Premium Collagen Complex": 100,
    "Kloubus": 25,
    "Collagen Hyaluro": null,
    "Venira Premium": 100,
    "MetaPWR Advantage": 40,
    "Collagen Beauty Remedy": 100,
    "Premium Collagen Peptides": null,
    "Collagen Drink (DrMax)": 100,
    "Collagen Beauty": 100,
    "Premium Marine Collagen": 70,
    "Marine Collagen Matrix": 70,
    "Rybí kolagen (Endala)": null,
    "Kolagen original premium": 100,
    "Collagen Forte (Greenfood)": 80,
    "Pure Collagen": 100,
    "Marine Collagen (Nordic)": 85,
    "Verisol Collagen Silk": 50,
    "Collagen Premium (Biostile)": 100,
    "Kolagen jahoda (Natural Protein)": 100,
    "Upgraded Collagen Complex": 100,
    "Hydrolyzovaný kolagen (BrainMarket)": 100,
    "Prémiový kolagen": 100,
    "Prémiový kolagenový drink": 100,
    "Ovonex|Kolagen": 100,
    "GlowGEN|Kolagen": 100
  };

  // Fua Fua reference (100%)
  var FF_REF = { kolagen: 3000, hyaluron: 200, q10: 100, karnosin: 500, vitc: 80 };

  var KEY_MAP = {
    kolagen:  'Množství kolagenu',
    hyaluron: 'Kyselina hyaluronová/ hyalutonát sodný',
    q10:      'Koenzym Q10',
    karnosin: 'L-karnosin',
    vitc:     'Vitamín C - kys.L-askorbová'
  };

  function parseMg(val) {
    if (!val || val === 0 || val === '0') return 0;
    var s = String(val).trim();
    if (s === 'čeká' || s === 'nezjištěno' || s === 'ano') return 0;
    if (s.indexOf('µg') !== -1) {
      return parseFloat(s.replace(/[^\d.,]/g,'').replace(',','.')) / 1000 || 0;
    }
    if (/^\d/.test(s) && s.indexOf('mg') === -1 && (s.indexOf('g') !== -1 || !isNaN(parseFloat(s)))) {
      var num = parseFloat(s.replace(/[^\d.,]/g,'').replace(',','.')) || 0;
      if (s.indexOf('g') !== -1 && s.indexOf('mg') === -1) return num * 1000;
      return num;
    }
    return parseFloat(s.replace(/[^\d.,]/g,'').replace(',','.')) || 0;
  }

  function parseKolagenMg(val) {
    if (!val || val === 0 || val === '0') return 0;
    var s = String(val).trim();
    if (s === 'čeká' || s === 'nezjištěno') return 0;
    var num = parseFloat(s.replace(/[^\d.,]/g,'').replace(',','.')) || 0;
    if (num < 100 && s.indexOf('mg') === -1) return num * 1000;
    return num;
  }

  function calcPct(mg, ref) {
    if (mg <= 0) return 0;
    return Math.round((mg / ref) * 100);
  }

  function formatMg(mg) {
    if (mg <= 0) return '';
    if (mg < 1) return Math.round(mg * 1000) + ' µg';
    return (mg % 1 === 0 ? mg : mg.toFixed(0)) + ' mg';
  }

  function formatPctOrDavky(pct) {
    if (pct > 0) return pct + '%';
    return '—';
  }

  var sel = document.getElementById('sc2-select');
  if (!sel) return;

  PRODUCTS.sort(function(a, b) { return a['Brand'].localeCompare(b['Brand'], 'cs'); });

  sel.innerHTML = '';
  var defaultOpt = document.createElement('option');
  defaultOpt.value = 'default';
  defaultOpt.textContent = 'Běžný kolagen';
  sel.appendChild(defaultOpt);

  PRODUCTS.forEach(function(p, i) {
    var o = document.createElement('option');
    o.value = i;
    o.textContent = p['Brand'] + ' – ' + p['Produkt'];
    sel.appendChild(o);
  });

  function animateFF() {
    ['kolagen','hyaluron','q10','karnosin','vitc'].forEach(function(k) {
      var el = document.getElementById('f2-fill-ff-' + k);
      if (!el) return;
      el.style.width = '0%';
      setTimeout(function() { el.style.width = '100%'; }, 200);
    });
  }

  var DEFAULT_VALS   = { kolagen: 40, hyaluron: 25, q10: 50, karnosin: 0, vitc: 100 };
  var DEFAULT_LABELS = { kolagen: '', hyaluron: '50 mg', q10: '50 mg', karnosin: '', vitc: '80 mg' };

  var LOW_FILL_THRESHOLD = 18;

  function renderFill(fillEl, labelEl, pct, labelText) {
    if (!fillEl) return;
    fillEl.style.width = '0%';
    var visualPct = Math.min(pct, 100);
    setTimeout(function() {
      fillEl.style.width = visualPct + '%';
      fillEl.style.minWidth = visualPct > 0 ? '50px' : '0';
      if (!labelEl) return;
      if (!labelText) {
        labelEl.textContent = '';
        labelEl.classList.remove('sc-cmp2__fill-label--outside');
        return;
      }
      labelEl.textContent = labelText;
      if (visualPct < LOW_FILL_THRESHOLD) {
        labelEl.classList.add('sc-cmp2__fill-label--outside');
      } else {
        labelEl.classList.remove('sc-cmp2__fill-label--outside');
      }
    }, 80);
  }

  function update(idx) {
    var keys = ['kolagen','hyaluron','q10','karnosin','vitc'];

    if (idx === 'default') {
      keys.forEach(function(k) {
        var fill  = document.getElementById('f2-fill-' + k);
        var pctEl = document.getElementById('f2-pct-' + k);
        var lbl   = document.getElementById('f2-label-' + k);
        var brnd  = document.getElementById('f2-brand-' + k);
        if (brnd)  brnd.textContent  = 'Běžný kolagen';
        if (pctEl) pctEl.textContent = formatPctOrDavky(DEFAULT_VALS[k]);
        renderFill(fill, lbl, DEFAULT_VALS[k], DEFAULT_LABELS[k]);
      });
      return;
    }

    var p = PRODUCTS[parseInt(idx, 10)];
    if (!p) return;

    var displayName = p['Brand'] + ' – ' + p['Produkt'];

    keys.forEach(function(k) {
      var jsonKey = KEY_MAP[k];
      var mg  = k === 'kolagen' ? parseKolagenMg(p[jsonKey]) : parseMg(p[jsonKey]);
      var pct;

      if (k === 'kolagen') {
        // Kolagenový efekt — natvrdo z mapy, ne přepočet z mg
        var efekt = KOLAGEN_EFEKT[p['Brand'] + '|' + p['Produkt']];
        if (efekt == null) efekt = KOLAGEN_EFEKT[p['Produkt']];
        pct = (efekt != null) ? efekt : 0;
      } else {
        pct = calcPct(mg, FF_REF[k]);
      }

      var fill  = document.getElementById('f2-fill-' + k);
      var pctEl = document.getElementById('f2-pct-' + k);
      var lbl   = document.getElementById('f2-label-' + k);
      var brnd  = document.getElementById('f2-brand-' + k);

      if (brnd)  brnd.textContent  = displayName;
      if (pctEl) pctEl.textContent = formatPctOrDavky(pct);
      // Pro kolagen nezobrazujeme mg label (efekt, ne množství)
      var labelText = mg > 0 ? formatMg(mg) : '';
      renderFill(fill, lbl, pct, labelText);
    });
  }

  sel.addEventListener('change', function() {
    var v = this.value;
    update(v === 'default' ? 'default' : parseInt(v, 10));
  });

  function init() {
    animateFF();
    update('default');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

// ── Rozbalovací vysvětlení u "Kolagenový efekt" ──
// Injektuje toggle button + explain text přímo do DOM, bez změny liquid souboru

(function () {
  function initKolagenToggle() {
    var nameSpan = null;
    document.querySelectorAll('.sc-cmp2__bar-label').forEach(function(el) {
      var s = el.querySelector('.sc-cmp2__bar-name');
      if (s && s.textContent.trim() === 'Kolagenový efekt') nameSpan = s;
    });
    if (!nameSpan || document.getElementById('kolagen-efekt-toggle')) return;

    // CSS
    if (!document.getElementById('kolagen-efekt-styles')) {
      var style = document.createElement('style');
      style.id = 'kolagen-efekt-styles';
      style.textContent = [
        '.sc-cmp2__bar-name--toggle{background:none;border:none;cursor:pointer;font-family:Georgia,serif;font-size:18px;font-weight:700;color:#1A0A08;line-height:1.2;text-align:left;padding:0;display:flex;align-items:center;gap:6px}',
        '.sc-cmp2__bar-name--toggle:hover{color:#6B1F2A}',
        '.sc-cmp2__toggle-icon{width:14px;height:14px;flex-shrink:0;color:#6B1F2A}',
        '#kolagen-efekt-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:9998;align-items:center;justify-content:center}',
        '#kolagen-efekt-overlay.is-open{display:flex}',
        '#kolagen-efekt-dialog{background:#fff;border-radius:16px;padding:36px 40px 32px;max-width:480px;width:calc(100% - 40px);position:relative;z-index:9999;box-shadow:0 8px 40px rgba(74,22,40,0.18)}',
        '#kolagen-efekt-dialog h3{font-family:Georgia,serif;font-size:20px;font-weight:700;color:#4a1628;margin:0 0 14px}',
        '#kolagen-efekt-dialog p{font-family:Arial,Helvetica,sans-serif;font-size:13.5px;color:#4a1628;line-height:1.65;margin:0 0 12px}',
        '#kolagen-efekt-dialog p:last-of-type{margin-bottom:0}',
        '#kolagen-efekt-dialog strong{color:#4a1628}',
        '#kolagen-efekt-close{position:absolute;top:14px;right:16px;background:none;border:none;cursor:pointer;font-size:22px;line-height:1;color:#4a1628;padding:4px 8px}'
      ].join('');
      document.head.appendChild(style);
    }

    // Overlay + dialog
    var overlay = document.createElement('div');
    overlay.id = 'kolagen-efekt-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML = [
      '<div id="kolagen-efekt-dialog">',
        '<button id="kolagen-efekt-close" aria-label="Zavřít">&times;</button>',
        '<h3>Proč se doporučené denní dávky liší?</h3>',
        '<p>Doporučená dávka kolagenu závisí nejen na jeho molekulové hmotnosti, ale také na složení a zastoupení jednotlivých peptidů. Nízkomolekulární kolagen obsahuje kratší peptidy, které může organismus snadno vstřebat. Díky tomu může být účinná denní dávka konkrétního produktu nižší.</p>',
        '<p><strong>500–1 000 Da</strong><br>Nízkomolekulární kolagenové peptidy Fua Fua<br>Doporučená denní dávka: <strong>2,5–4 g</strong></p>',
        '<p><strong>2 000–4 000 Da</strong><br>Běžné hydrolyzované kolagenové peptidy<br>Obvykle užívaná denní dávka: <strong>5 g</strong></p>',
      '</div>'
    ].join('');
    document.body.appendChild(overlay);

    function openDialog() { overlay.classList.add('is-open'); }
    function closeDialog() { overlay.classList.remove('is-open'); }

    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeDialog(); });
    overlay.querySelector('#kolagen-efekt-close').addEventListener('click', closeDialog);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDialog(); });

    // Nahraď span tlačítkem
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'kolagen-efekt-toggle';
    btn.className = 'sc-cmp2__bar-name sc-cmp2__bar-name--toggle';
    btn.innerHTML = 'Kolagenový efekt <svg class="sc-cmp2__toggle-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.5"/><path d="M8 7v4M8 5.5v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    btn.addEventListener('click', openDialog);
    nameSpan.replaceWith(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKolagenToggle);
  } else {
    initKolagenToggle();
  }
})();